import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-00656c84"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dashboard-sider__decor",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  class: "dashboard-sider__brand-mark"
}
const _hoisted_4 = {
  key: 1,
  class: "dashboard-sider__brand-text"
}
const _hoisted_5 = { class: "dashboard-sider__brand-title" }
const _hoisted_6 = { class: "dashboard-sider__brand-tagline" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "dashboard-sider__divider" }, null, -1))
const _hoisted_8 = { class: "dashboard-sider__content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-right-from-bracket dashboard-sider__back-icon" }, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "dashboard-sider__back-label"
}

import { ref, onMounted, onBeforeUnmount, watch, computed, h } from "vue";
import type { ItemType } from "ant-design-vue";
import { apiView } from "@/api/index";
import { ADMIN_SLIDE_MENU } from '@/const/ApiRedis'
import { useRouter } from "vue-router";
import { HOME } from '@/const/path'
import utils from "@/utils/Utils";
import commons from "@/utils/Common";
import DashboardMenuItem from "@/components/Sidebars/DashboardMenuItem.vue";

const LG_BREAKPOINT = 992;
const MINI_WIDTH = 72;

interface SlideMenuItem {
  id: number;
  parent: number;
  linkTo: string;
  linkLabel: string;
  icon?: string;
  quantity?: number | string | null;
  badge?: number | string | null;
  badgeCount?: number | string | null;
  count?: number | string | null;
  pendingCount?: number | string | null;
  children?: SlideMenuItem[];
}

interface Props {
  sidebarCollapsed: boolean;
  sidebarColor: string;
  sidebarTextColor: string;
  sidebarSelectedTextColor: string;
  sidebarTheme: string;
  backLabel?: string;
  backUrl?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardSidebar',
  props: {
    sidebarCollapsed: { type: Boolean, default: false },
    sidebarColor: { default: "primary" },
    sidebarTextColor: { default: "primary" },
    sidebarSelectedTextColor: { default: "white" },
    sidebarTheme: { default: "light" },
    backLabel: { default: "Quay lại Trang chủ" },
    backUrl: { default: "" }
  },
  emits: ["toggleSidebar"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const propsData = __props;

const sidebarColorVal = computed(() => propsData.sidebarColor ?? "primary");
const sidebarTextColorVal = computed(() => propsData.sidebarTextColor ?? "primary");
const sidebarSelectedTextColorVal = computed(
  () => propsData.sidebarSelectedTextColor ?? "white"
);
const sidebarThemeVal = computed(() => propsData.sidebarTheme ?? "light");

const router = useRouter();
const menuList = ref<SlideMenuItem[]>([]);
const openKeys = ref<string[]>([]);
const selectedKeys = ref<string[]>([]);
const isMobile = ref(false);
const company = ref<Record<string, string>>({});

const activePath = computed(() => router.currentRoute.value.path);
const isMiniMode = computed(() => propsData.sidebarCollapsed && !isMobile.value);
const isHiddenMode = computed(() => propsData.sidebarCollapsed && isMobile.value);
const collapsedWidth = computed(() => (isMobile.value ? 0 : MINI_WIDTH));
const companyName = computed(
  () => company.value.sub_name || company.value.subName || "KIMAHOME"
);
const companyTagline = computed(
  () => company.value.summary || "LUXURY FURNITURE"
);
const companyLogo = computed(
  () => company.value.logo || company.value.urlLogo || ""
);
const companyInitial = computed(() => companyName.value.charAt(0).toUpperCase());

/** Always unique — avoids Ant Menu ghost titles when linkTo collides */
const menuItemKey = (item: SlideMenuItem) => `menu-${item.id}`;

const mapToAntdItems = (items: SlideMenuItem[], level = 0): ItemType[] =>
  items.map((item) => {
    const key = menuItemKey(item);
    const label = h(DashboardMenuItem, {
      item,
      showIcon: level === 0,
      iconOnly: isMiniMode.value && level === 0,
      isChild: level > 0,
    });

    if (item.children?.length) {
      return {
        key,
        label,
        children: mapToAntdItems(item.children, level + 1),
      };
    }

    return { key, label };
  });

const antdMenuItems = computed(() => mapToAntdItems(menuList.value));

const findMenuItemByKey = (
  items: SlideMenuItem[],
  key: string
): SlideMenuItem | null => {
  for (const item of items) {
    if (menuItemKey(item) === key) {
      return item;
    }
    if (item.children?.length) {
      const found = findMenuItemByKey(item.children, key);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

const updateViewport = () => {
  isMobile.value = window.innerWidth < LG_BREAKPOINT;
};

const normalizeFlatMenu = (res: any): SlideMenuItem[] => {
  const payload = res?.data?.data ?? res?.data;
  if (Array.isArray(payload)) {
    return payload;
  }
  if (Array.isArray(payload?.body)) {
    return payload.body;
  }
  if (Array.isArray(res?.data?.body)) {
    return res.data.body;
  }
  const parsed = utils.parseJSON(payload);
  if (Array.isArray(parsed)) {
    return parsed;
  }
  if (Array.isArray(parsed?.body)) {
    return parsed.body;
  }
  return [];
};

const buildMenuTree = (flat: SlideMenuItem[]): SlideMenuItem[] => {
  const map = new Map<number, SlideMenuItem>();

  flat.forEach((item) => {
    map.set(item.id, { ...item, children: [] });
  });

  const roots: SlideMenuItem[] = [];

  flat.forEach((item) => {
    const node = map.get(item.id);
    if (!node) {
      return;
    }
    const parentId = Number(item.parent) || 0;
    if (parentId === 0) {
      roots.push(node);
      return;
    }
    const parent = map.get(parentId);
    if (parent?.children) {
      parent.children.push(node);
    } else {
      roots.push(node);
    }
  });

  const trimEmptyChildren = (nodes: SlideMenuItem[]) => {
    nodes.sort((a, b) => a.id - b.id);
    nodes.forEach((node) => {
      if (node.children?.length) {
        trimEmptyChildren(node.children);
      } else {
        delete node.children;
      }
    });
  };

  trimEmptyChildren(roots);
  return roots;
};

const findOpenKeysForPath = (
  items: SlideMenuItem[],
  path: string,
  parents: string[] = []
): string[] | null => {
  for (const item of items) {
    if (item.linkTo === path) {
      return parents;
    }
    if (item.children?.length) {
      const found = findOpenKeysForPath(item.children, path, [
        ...parents,
        menuItemKey(item),
      ]);
      if (found !== null) {
        return found;
      }
    }
  }
  return null;
};

const syncMenuState = () => {
  const path = activePath.value;
  const matchKey =
    findMenuKeyByPath(menuList.value, path) ?? path;
  selectedKeys.value = [matchKey];

  const keys = findOpenKeysForPath(menuList.value, path);
  if (keys !== null) {
    openKeys.value = keys;
  }
};

const findMenuKeyByPath = (
  items: SlideMenuItem[],
  path: string
): string | null => {
  for (const item of items) {
    if (item.linkTo === path) {
      return menuItemKey(item);
    }
    if (item.children?.length) {
      const found = findMenuKeyByPath(item.children, path);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

const loadData = async () => {
  const res: any = await apiView(ADMIN_SLIDE_MENU);
  const flat = normalizeFlatMenu(res);
  menuList.value = buildMenuTree(mockSlideQuantities(flat));
  syncMenuState();
};

/** Demo: random quantity for slide menu badges (0 / null → hidden, >999 → 999+) */
const mockSlideQuantities = (items: SlideMenuItem[]): SlideMenuItem[] => {
  // const rollQuantity = (): number | null => {
  //   const roll = Math.random();
  //   if (roll < 0.15) return null;
  //   if (roll < 0.25) return 0;
  //   // ~40% values > 999 to demo "999+"
  //   if (roll < 0.65) return Math.floor(Math.random() * 9000) + 1000;
  //   return Math.floor(Math.random() * 999) + 1;
  // };

  // return items.map((item) => ({
  //   ...item,
  //   quantity: rollQuantity(),
  // }));
  return  items;
};

const loadCompany = () => {
  const data = commons.getCokiesCompany();
  if (data) {
    company.value = data;
  }
};

const onMenuClick = (item: SlideMenuItem) => {
  if (item.linkTo?.trim()) {
    router.push(item.linkTo);
  }
};

const onAntMenuClick = (info: { key: string | number }) => {
  const item = findMenuItemByKey(menuList.value, String(info.key));
  if (item && !item.children?.length) {
    onMenuClick(item);
  }
};

const onCollapse = (collapsed: boolean) => {
  emit("toggleSidebar", collapsed);
};

const onBreakpoint = (broken: boolean) => {
  isMobile.value = broken;
  emit("toggleSidebar", broken);
};

const goHome = () => {
  router.push(HOME);
};

const onBack = () => {
  const url = propsData.backUrl?.trim();
  if (url) {
    window.location.href = url;
    return;
  }
  goHome();
};

onMounted(async () => {
  updateViewport();
  loadCompany();
  await loadData();
  window.addEventListener("resize", updateViewport);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateViewport);
});

watch(activePath, () => {
  syncMenuState();
});

watch(menuList, () => syncMenuState(), { deep: true });

watch(isMiniMode, (mini) => {
  if (mini) {
    openKeys.value = [];
  } else {
    syncMenuState();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!

  return (_openBlock(), _createBlock(_component_a_layout_sider, {
    collapsible: "",
    class: _normalizeClass(["sider-primary dashboard-sider", [
      'ant-layout-sider-' + sidebarColorVal.value,
      'ant-layout-sider-' + sidebarThemeVal.value,
      {
        'dashboard-sider--collapsed': _ctx.sidebarCollapsed,
        'dashboard-sider--mini': isMiniMode.value,
        'dashboard-sider--hidden': isHiddenMode.value,
      },
    ]]),
    breakpoint: "lg",
    "collapsed-width": collapsedWidth.value,
    width: "256px",
    collapsed: _ctx.sidebarCollapsed,
    onCollapse: onCollapse,
    onBreakpoint: onBreakpoint,
    trigger: null,
    theme: "light",
    style: { backgroundColor: 'transparent' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["dashboard-sider__inner", [
        `dashboard-sider__inner--${sidebarColorVal.value}`,
        `dashboard-sider__text--${sidebarTextColorVal.value}`,
        `dashboard-sider__selected--${sidebarSelectedTextColorVal.value}`,
      ]])
      }, [
        _hoisted_1,
        _createElementVNode("div", {
          class: "dashboard-sider__brand",
          onClick: goHome
        }, [
          (isMiniMode.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (companyLogo.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: companyLogo.value,
                      alt: companyName.value,
                      class: "dashboard-sider__brand-img"
                    }, null, 8, _hoisted_2))
                  : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(companyInitial.value), 1))
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(companyName.value), 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(companyTagline.value), 1)
              ]))
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_a_menu, {
            mode: "inline",
            class: "dashboard-sidebar-menu",
            openKeys: openKeys.value,
            "onUpdate:openKeys": _cache[0] || (_cache[0] = ($event: any) => ((openKeys).value = $event)),
            selectedKeys: selectedKeys.value,
            "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((selectedKeys).value = $event)),
            "inline-collapsed": isMiniMode.value,
            "inline-indent": 24,
            items: antdMenuItems.value,
            onClick: onAntMenuClick
          }, null, 8, ["openKeys", "selectedKeys", "inline-collapsed", "items"])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "dashboard-sider__back",
          onClick: onBack
        }, [
          _hoisted_9,
          (!isMiniMode.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.backLabel), 1))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["collapsed-width", "collapsed", "class"]))
}
}

})